import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClassificationGameSelectorComponent } from './classification-game-selector/classification-game-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { ClassificationGameCoreService } from './classification-game-core.service';

@NgModule({
  declarations: [ClassificationGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [ClassificationGameCoreService],
  exports: [ClassificationGameSelectorComponent],
})
export class ClassificationGameCoreModule {}
